import Headbar from '../components/Headbar';
import DiscoverCategories from '../components/Discover/DiscoverCategories';

export default function Discover() {
  return (
    <>
      <Headbar />
      <DiscoverCategories />
    </>
  );
}
